var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from 'layout/atoms/Button/Button';
import ColorDot from 'layout/atoms/ColorDot';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Tooltip from 'layout/atoms/Tooltip';
import { changeComponentStatus } from 'store/componentsSlice';
const STATUSES = ['ACTIVE', 'ARCHIVED'];
const STATUS_LABEL_KEYS = {
    ACTIVE: 'status_active_alternative',
    ARCHIVED: 'status_archived_alternative',
};
const STATUS_COLORS = {
    ACTIVE: 'var(--semantic-text-onsubtle-positive)',
    ARCHIVED: 'var(--status-color-neutral)',
};
function ComponentStatusDropdown({ componentId, status, size = 'xs', }) {
    const dispatch = useDispatch();
    const { t } = useTranslation('specification');
    const [loading, setLoading] = useState(false);
    const currentStatus = status === 'ARCHIVED' ? 'ARCHIVED' : 'ACTIVE';
    const handleSelect = useCallback((nextStatus) => __awaiter(this, void 0, void 0, function* () {
        if (nextStatus === currentStatus) {
            return;
        }
        setLoading(true);
        yield dispatch(changeComponentStatus({ componentId, status: nextStatus }));
        setLoading(false);
    }), [dispatch, componentId, currentStatus]);
    return (React.createElement("div", { onClick: (e) => e.stopPropagation() },
        React.createElement(Dropdown, { position: "bottomLeft", trigger: React.createElement(Tooltip, { content: t('CHANGE_STATUS'), delay: 300 },
                React.createElement(Button, { size: size, theme: "ghost", loading: loading, leftIcon: React.createElement(ColorDot, { color: STATUS_COLORS[currentStatus], check: currentStatus === 'ACTIVE' }) }, t(STATUS_LABEL_KEYS[currentStatus]))) }, STATUSES.map((option) => (React.createElement(Button, { key: option, align: "left", theme: option === currentStatus ? 'fill' : 'ghost', leftIcon: React.createElement(ColorDot, { color: STATUS_COLORS[option], check: option === 'ACTIVE' }), onClick: () => handleSelect(option) }, t(STATUS_LABEL_KEYS[option])))))));
}
export default ComponentStatusDropdown;
